import advisorResource from "@/shared/resource/advisor3";
import { authorizedAxios } from "./authorizedAxios";
import { AdvisorAction } from "@/admin/types";
import {
    Advisor3Rule, AdvisorRulePreviewResult, Advice3, AdvisorEventType,
    AdvisorPreviewTemplateResponse, ActionHistory, MessageCenterGetMessagesResponse, MessageCenterMessage
} from "@/shared/types";

export function getAction (actionId: number) {
  return authorizedAxios.get<AdvisorAction>(advisorResource.actionById(actionId));
}

export function saveAction (data: AdvisorAction) {
  return authorizedAxios.put<number>(advisorResource.action(), data);
}

export function testAction (data: {actionId: number, ruleExectionId: number}) {
  return authorizedAxios.post<string>(advisorResource.action(), data);
}

export function get (id: number) {
  return authorizedAxios.get(advisorResource.ruleById(id));
}

export function getAll () {
  return authorizedAxios.get<Advisor3Rule[]>(advisorResource.rule());
}

export function getAllActions () {
  return authorizedAxios.get<AdvisorAction[]>(advisorResource.action());
}
export function save (model: Advisor3Rule) {
  return authorizedAxios.put<boolean | number>(advisorResource.rule(), model);
}

export function previewRule (model: Advisor3Rule) {
  return authorizedAxios.post<AdvisorRulePreviewResult>(advisorResource.rulePreview(), model);
}

export function getMedia (actionId: number) {
  return authorizedAxios.get<string[]>(advisorResource.media(actionId));
}

export function saveMedia (actionId: number, mediaFiles: any) {
    return authorizedAxios.postFiles(advisorResource.media(actionId), mediaFiles);
}

export function removeMedia (expenseId: number, filename: string) {
  return authorizedAxios.delete(advisorResource.media(expenseId, filename));
}

export function mediaGetDownloadLink (expenseId: number, filename: string) {
  return authorizedAxios.get<string>(advisorResource.mediaS3PreSignedUrl(expenseId, filename));
}

export function softDeleteRule (id: number) {
  return authorizedAxios.delete<boolean>(advisorResource.ruleById(id));
}

export function deleteAction (actionId: number) {
  return authorizedAxios.delete<boolean>(advisorResource.actionById(actionId));
}

export function render (actionId: number, ruleExecutionId: number) {
  return authorizedAxios.post<string>(advisorResource.render(), { actionId, ruleExecutionId});
}

export function previewTemplate (actionId: number, ruleId: number) {
    return authorizedAxios.post<AdvisorPreviewTemplateResponse[]>(advisorResource.previewTemplate(), { actionId, ruleId });
}

export function getAdvice () {
  return authorizedAxios.get<Advice3[]>(advisorResource.getAdvice());
}

export function getAdviceLastUpdated () {
  return authorizedAxios.get<string>(advisorResource.getAdviceLastUpdated());
}

export function saveEvent (event: AdvisorEventType) {
  return authorizedAxios.post<boolean>(advisorResource.saveEvent(), {eventType: event});
}

export function saveActionHistory (actionHistory: ActionHistory) {
  return authorizedAxios.post<boolean>(advisorResource.saveActionHistory(), actionHistory);
}

export function dismissAdvice (data: {actionId: string, ruleExecutionId: number}) {
  return authorizedAxios.post<void>(advisorResource.dismissAdvice(data.actionId, data.ruleExecutionId));
}

export function getMessages () {
    return authorizedAxios.get<MessageCenterGetMessagesResponse>(advisorResource.getMessages());
}

export function getMessage (messageId: string) {
    return authorizedAxios.get<MessageCenterMessage>(advisorResource.getMessage(messageId));
}